import React, { useEffect } from 'react';
import DefectsGtc from '../../../../tabs/defectsGtc';

const DefectsTab = () => {
  useEffect(() => {
    console.log('build: 02-10-2026 12:27 PM EST');
  }, []);

  return <DefectsGtc />;
};

export default DefectsTab;
